<template>
    <div class="wallet-dropdown-mobile">
        <div v-on:click="copyAddress" class="wallet-dropdown-mobile__item">
            <icon-copy v-show="!successVisible" />
            <icon-success v-show="successVisible" />
            {{ $t('tonconnect.copy_address') }}
        </div>
        <router-link v-on:click.native="openAddressPage" v-bind:to="getLink" class="wallet-dropdown-mobile__item router-link__no-style">
            <icon-explore />{{ $t('tonconnect.explore_address') }}
        </router-link>
        <div v-on:click="disconnectWallet" class="wallet-dropdown-mobile__item">
            <icon-disconnect />{{ $t('tonconnect.disconnect_wallet') }}
        </div>
    </div>
</template>

<script>
import IconCopy from '@img/icons/tonscan/copy-14.svg?vue';
import IconSuccess from '@primer/octicons/build/svg/check-16.svg?vue';
import IconExplore from '@primer/octicons/build/svg/globe-16.svg?vue';
import IconDisconnect from '@primer/octicons/build/svg/sign-out-16.svg?vue';
import { showToast } from '~/toast';
import { Address } from '~/tonweb';

export default {
    name: 'ConnectWalletDropdown',
    data() {
        return {
            successVisible: false,
        };
    },

    computed: {
        address() {
            const raw = this.$tonConnect.wallet.account.address;
            return new Address(raw).toString({
                userFriendly: true,
                bouncable: false,
                testOnly: false,
            });
        },

        getLink() {
            return { name: 'address', params: { address: this.address } };
        },
    },

    methods: {
        async copyAddress() {
            try {
                await navigator.clipboard.writeText(this.address);
            } catch {
                this.copyToClipboardFallback(this.address);
            }
            this.successVisible = true;

            showToast(this.$t('address.info.copy_success'));

            setTimeout(() => {
                this.successVisible = false;
            }, 1800);
        },

        openAddressPage() {
            // Close the dropdown
            this.$emit('open-address-page');
        },

        async disconnectWallet() {
            await this.$tonConnect.disconnect();
            // Close the dropdown
            this.$emit('disconnect-wallet');
        },
    },

    components: {
        IconCopy,
        IconSuccess,
        IconExplore,
        IconDisconnect,
    },
};
</script>

<style lang="scss">
.wallet-dropdown-mobile {
    position: absolute;
    background-color: var(--theme-popup-background);
    border-radius: 12px;
    cursor: pointer;
    border: 1px solid var(--card-border-color);
    bottom: 134px;
    left: 18px;
    right: 18px;
    padding: 8px;
    z-index: 10000;

    &__item {
        display: flex!important;
        align-items: center;
        justify-content: flex-start;
        padding: 12px 13px 12px 11px;
        border-radius: 8px;
        gap: 10px;
        white-space: nowrap;
        cursor: pointer;
        user-select: none;

        svg {
            width: 16px;
            color: var(--body-muted-text-color);
            fill: var(--body-muted-text-color);
        }

        &:hover {
            background: var(--body-light-muted-color);
        }
    }
}
</style>
